export const DEBOUNCE_TIME = 300;

export const DEFAULT_LOOKUP_LENGTH = 100;

/**
 * Single source of truth for "is this string a usable email address" on the client.
 * Mirrors `emailPattern` in internal/domain/tenant_settings.go — keep the two in sync.
 */
export const EMAIL_PATTERN = /^[^\s@"]+@[^\s@"]+\.[A-Za-z]{2,}$/;

export const ASYNC_JOB_POLL_INTERVAL_MS = 5000;

// Google measures drive time against live traffic, so a cached result ages faster than the app default.
export const PLANT_DISTANCES_CACHE_TIME = 5 * 60 * 1000;

export const ASYNC_JOB_FAILED_ITEMS_PREVIEW_LIMIT = 3;

export const ESCALATION_DATE_WINDOW_OPTIONS_DAYS = [30, 60, 90] as const;

export const EMAIL_SUGGESTIONS_PER_PAGE = 10;

export const MIN_EMAIL_SUGGESTION_CHARS = 2;

export const HTTP_BAD_REQUEST = 400;

export const HTTP_UNAUTHORIZED = 401;

export const HTTP_FORBIDDEN = 403;

export const HTTP_NOT_FOUND = 404;

export const HTTP_CONFLICT = 409;

export const HTTP_UNPROCESSABLE_ENTITY = 422;

export const HTTP_INTERNAL_SERVER_ERROR = 500;

export const HTTP_BAD_GATEWAY = 502;

export const HTTP_SERVICE_UNAVAILABLE = 503;

export const HTTP_GATEWAY_TIMEOUT = 504;

export const STALE_VERSION_ERROR_KIND = 'stale_version';

export const NYLAS_AUTHENTICATION_ERROR_KIND = 'api.authentication_error';
